import React, { useState } from 'react';
import AceEditor from 'react-ace';
import axios from 'axios';
import Papa from 'papaparse';
import 'ace-builds/src-noconflict/mode-sql';
import 'ace-builds/src-noconflict/theme-github';
import './sqltutorial.css';
import './freeChartBuilder.css'

function FreeChartBuilder() {
  const [query, setQuery] = useState('Give me a cool chart based on my data!');
  const [aiResult, setAiResult] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [csvData, setCsvData] = useState(null);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      Papa.parse(file, {
        complete: (result) => {
          setCsvData(result.data);
        },
        header: true,
      });
    }
  };

  const freeChartBuilder = async () => {
    if (isLoading) return;
    if (csvData == null) return;
    setIsLoading(true);

    const jsonDataSample = JSON.stringify(csvData.slice(0, 5));
    const payload = {
      query,
      csvData: jsonDataSample,
    };

    try {
      const response = await axios.post('https://us-central1-explo-website-tools.cloudfunctions.net/buildFreeChart', payload);
      const csvDataJson = JSON.stringify(csvData);
      const aiResponseWithCsvData = `<script type="text/javascript">var csvData = ${csvDataJson};</script>${response.data.htmlContent}`;

      console.log(aiResponseWithCsvData)
      setAiResult(aiResponseWithCsvData);
    } catch (error) {
      console.error('Error creating chart:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="app-container">
      <h1>Free AI Chart Builder</h1>
      <div className="query-input">
        <AceEditor
          mode="sql"
          theme="github"
          name="queryEditor"
          onChange={value => setQuery(value)}
          fontSize={14}
          value={query}
          showPrintMargin={true}
          showGutter={true}
          highlightActiveLine={true}
          setOptions={{
            enableBasicAutocompletion: false,
            enableLiveAutocompletion: false,
            enableSnippets: false,
            showLineNumbers: true,
            tabSize: 2,
          }}
          style={{ width: '100%', minHeight: '50px', maxHeight: '150px' }}
        />
<label className="custom-file-upload">
  <input type="file" accept=".csv" onChange={handleFileUpload}/>
  {csvData ? "CSV Uploaded!" : "Click me to upload a CSV of your data"}
</label>
        <button onClick={freeChartBuilder} style={{ marginTop: '10px', marginLeft: "10px" }}>Build Free Chart with AI</button>
        {isLoading && <p>Loading chart...</p>}
      </div>
      {aiResult && (
        <div className="chart-output">
          <h2>Chart Output</h2>
          <iframe
            srcDoc={aiResult}
            style={{height: '300px', border: '1px solid #ccc' }}
            sandbox="allow-scripts allow-same-origin"
            title="AI Generated Chart"
          ></iframe>
        </div>
      )}
    </div>
  );
}

export default FreeChartBuilder;